import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

export abstract class AbstractFormComponent {
  constructor(public form?: FormGroup) {}

  protected getControl(fieldOrFormGroup: string | FormGroup, field?: string): AbstractControl | null {
    return typeof fieldOrFormGroup === 'string' ? this.form.get(fieldOrFormGroup) : fieldOrFormGroup.get(field);
  }

  isFormGroupValid(formGroup?: FormGroup): boolean {
    return (formGroup || this.form).valid;
  }

  isFieldInvalid(fieldOrFormGroup: string | FormGroup, field?: string): boolean {
    const control: AbstractControl = this.getControl(fieldOrFormGroup, field);
    return control.invalid && (control.dirty || control.touched);
  }

  fieldHasError(fieldOrFormGroup: string | FormGroup, fieldOrErrorCode: string, errorCode?: string): boolean {
    const control = this.getControl(fieldOrFormGroup, fieldOrErrorCode);
    errorCode = typeof fieldOrFormGroup === 'string' ? fieldOrErrorCode : errorCode;
    return control.hasError(errorCode) && (control.dirty || control.touched);
  }

  markAllFormFieldsTouched(formGroup?: FormGroup): void {
    formGroup = formGroup || this.form;
    Object.keys(formGroup.controls).forEach(
      (field: string): void => {
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
          this.markAllFormFieldsTouched(control);
        }
      }
    );
  }

  getAllInvalidFields(formGroup?: FormGroup | FormGroup[], limit?: number): AbstractControl[] {
    const formGroupArray: FormGroup[] = [].concat.apply([], [formGroup || this.form]);
    const invalidControlArray: AbstractControl[] = [];

    if (typeof limit === 'undefined' || limit <= 0) {
      limit = Number.MAX_SAFE_INTEGER;
    }

    for (const group of formGroupArray) {
      for (const field of Object.keys(group.controls)) {
        if (limit === 0) {
          break;
        }

        const control = group.get(field);
        if (control instanceof FormControl) {
          if (!control.valid) {
            invalidControlArray.push(control);
            --limit;
          }
        } else if (control instanceof FormGroup) {
          const invalidFields = this.getAllInvalidFields(control, limit);
          invalidControlArray.concat(invalidFields);
          limit -= invalidFields.length;
        }
      }

      if (limit === 0) {
        break;
      }
    }

    return invalidControlArray;
  }

  setFocusOnFirstInvalidField(baseNodeSelector?: NodeSelector): void {
    const elFirstInvalid: HTMLElement = (baseNodeSelector || document).querySelector('.ng-invalid:not(form)');
    if (elFirstInvalid != null) {
      elFirstInvalid.scrollIntoView({ behavior: 'instant', block: 'start' });
      elFirstInvalid.focus();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/global/abstract-form.component.ts